// SelectExternalCompany, выбор внешней компании
import { useEffect } from 'react';
import { Select } from 'antd';
import { useSelectedExternalCompany } from 'hooks';
import { filterOption } from 'helpers';

import { useCompaniesStore } from 'storeZustand';
import { useShallow } from 'zustand/react/shallow';

const SelectExternalCompany = ({ isCheckedFiz }) => {
	// Выбранная компания оптовик
	const [
		selectedExternalCompany,
		clearSelectedExternalCompany
	] = useCompaniesStore(useShallow((state) => [
		state.selectedExternalCompany,
		state.clearSelectedExternalCompany
	]));

	// Список внешних компаний для селекта
	const {
		externalCompaniesList,
		handleExternalCompanyChange,
	} = useSelectedExternalCompany();

	useEffect(() => {
		if (isCheckedFiz) {
			clearSelectedExternalCompany();
		}
	}, [isCheckedFiz]);

	return (
		<Select
			showSearch
			placeholder="Выбрать заказчика"
			optionFilterProp="children"
			style={{ width: '100%' }}
			allowClear
			value={selectedExternalCompany || undefined}
			onChange={handleExternalCompanyChange}
			options={externalCompaniesList}
			filterOption={filterOption}
			disabled={isCheckedFiz}
		/>
	)
}

export default SelectExternalCompany;